export const WARNING_SOURCES = {
  VALIDATION: 'validation',
  RULES: 'rules',
  AUTOCOMPLETE: 'autocomplete',
  NUMERIC_TEXT_BOX_VALIDATION: 'numericTextBoxValidation',
  DATE_BOX_VALIDATION: 'dateBoxValidation',
  SERVER: 'server',
  ASSISTANT: 'assistant',
  EDITOR: 'editor',
  ARCHIVE_MODE: 'archiveMode',
  OFFLINE_MODE: 'offlineMode',
};
